module.exports = __webpack_public_path__ + "static/media/sea_2_sm.4c6882ad.JPG";